// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colortb div.resHtml tr td:nth-child(2){padding-right:0}.colortb div.resHtml .t_r{padding-right:10px}.fontSizeUp{font-size:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
